import { Button } from 'dingtalk-design-mobile'
import './RightsServiceSuccess.less'
import useHistory from '@/hooks/useHistory'

const RightsServiceSuccess = () => {

  const history = useHistory()

  const handleClick = () => {
    history.back(3)
  }
  return (
    <div className="pg-rights-service-success">
      <div className='pg-rights-service-success--container'>
        <img className='icon' src='https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/advice/success-icon.png' />
        <div className='status'>提交成功</div>
        <div className='tips'>法律专员将尽快联系您</div>
        <Button className='btn' onClick={handleClick}>完成</Button>
      </div>
    </div>
  )
}

export default RightsServiceSuccess